function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// @ts-nocheck
//import "./main.sass";
import { Component } from "react";
import h from "@macrostrat/hyper";
import { Tag } from "@blueprintjs/core";
import Dropzone from "react-dropzone";
import classNames from "classnames";

var FileListItem = function FileListItem(props) {
  var file = props.file;
  return h(Tag, {
    icon: "document"
  }, file.name);
};

var FileList = function FileList(props) {
  var files = props.files,
      placeholder = props.placeholder;

  if (placeholder == null) {
    placeholder = "Choose file...";
  }

  if (files == null || !(files.length > 0)) {
    return placeholder;
  }

  return h("div.files", files.map(function (file) {
    return h(FileListItem, {
      file: file
    });
  }));
};

var FileUploadComponent = /*#__PURE__*/function (_Component) {
  _inherits(FileUploadComponent, _Component);

  var _super = _createSuper(FileUploadComponent);

  function FileUploadComponent(props) {
    var _this;

    _classCallCheck(this, FileUploadComponent);

    _this = _super.call(this, props);
    _this.renderDropzone = _this.renderDropzone.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FileUploadComponent, [{
    key: "renderDropzone",
    value: function renderDropzone(_ref) {
      var getRootProps = _ref.getRootProps,
          getInputProps = _ref.getInputProps,
          isDragActive = _ref.isDragActive;
      var files = this.props.files;
      var rootProps = getRootProps();
      var className = classNames("file-upload", {
        "dropzone-active": isDragActive
      });
      var inputProps = getInputProps();
      inputProps.style = {};
      inputProps.className = "bp4-large";
      var msg = "Drop files here";

      if (!isDragActive) {
        msg += ", or click to upload";
      }

      return h("div", _objectSpread({
        className: className
      }, rootProps), [h("label.bp4-file-input.bp4-large", [h("input", inputProps), h("div.bp4-file-upload-input", [h(FileList, {
        files: files,
        placeholder: msg
      })])])]);
    }
  }, {
    key: "render",
    value: function render() {
      return h(Dropzone, {
        onDrop: this.props.onAddFile,
        onFileDialogCancel: this.props.onCancel
      }, this.renderDropzone);
    }
  }]);

  return FileUploadComponent;
}(Component);

_defineProperty(FileUploadComponent, "defaultProps", {
  onAddFile: function onAddFile() {},
  onCancel: function onCancel() {}
});

export { FileUploadComponent };